import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { Tabs as T } from "radix-ui";
import { cn } from "@/lib/cn";

export const Tabs = T.Root;
export const TabsContent = T.Content;

export const TabsList = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<typeof T.List> & { variant?: "pill" | "line" }>(function TabsList({ className, variant = "pill", ...props }, ref) {
  return (
    <T.List
      ref={ref}
      className={cn(variant === "line" ? "flex h-11 min-w-0 items-stretch" : "inline-flex items-center gap-1 rounded-pill bg-slate-900/5 p-1", className)}
      {...props}
    />
  );
});

export const TabsTrigger = forwardRef<HTMLButtonElement, ComponentPropsWithoutRef<typeof T.Trigger> & { variant?: "pill" | "line" }>(function TabsTrigger({ className, variant = "pill", ...props }, ref) {
  return (
    <T.Trigger
      ref={ref}
      className={cn(
        variant === "line"
          ? "relative inline-flex h-11 min-w-0 flex-1 items-center justify-center px-1 text-[13px] font-medium text-slate-500 transition-colors outline-none hover:text-slate-800 focus-visible:text-slate-900 disabled:opacity-40 data-[state=active]:text-slate-900 data-[state=active]:after:absolute data-[state=active]:after:inset-x-1 data-[state=active]:after:bottom-0 data-[state=active]:after:h-0.5 data-[state=active]:after:rounded-full data-[state=active]:after:bg-primary"
          : "inline-flex h-9 items-center justify-center gap-1.5 whitespace-nowrap rounded-pill px-4 text-sm font-semibold text-slate-600 transition-colors hover:text-slate-900 data-[state=active]:bg-white data-[state=active]:text-slate-900 data-[state=active]:shadow-[0_1px_3px_rgb(15_23_42/0.12)] [&_svg]:size-4",
        className,
      )}
      {...props}
    />
  );
});
